module.exports = __webpack_public_path__ + "static/media/stress-large.f089e983.png";